class VideoUpdateManager {
  private static instance: VideoUpdateManager;
  private updateController: { stop: () => void; isRunning: () => boolean } | null = null;

  private constructor() {}

  public static getInstance(): VideoUpdateManager {
    if (!VideoUpdateManager.instance) {
      VideoUpdateManager.instance = new VideoUpdateManager();
    }
    return VideoUpdateManager.instance;
  }

  /**
   * Start video updates with safety checks
   * @param intervalMinutes - Update interval in minutes (default: 120)
   */
  public startUpdates(intervalMinutes: number = 120) {
    try {
      console.log('Starting video update service...');
      
      // Stop any existing updates first
      this.stopUpdates();
      
      // For now, we don't need to schedule updates since videos are user-generated
      this.updateController = {
        stop: () => {},
        isRunning: () => false
      };
      
      console.log(`Video updates initialized`);
    } catch (error) {
      console.error('Failed to start video updates:', error);
    }
  }

  /**
   * Safely stop all video updates
   */
  public stopUpdates() {
    try {
      if (this.updateController?.isRunning()) {
        this.updateController.stop();
        this.updateController = null;
        console.log('Video updates stopped successfully');
      }
    } catch (error) {
      console.error('Error stopping video updates:', error);
    }
  }

  /**
   * Check if updates are currently running
   */
  public isRunning(): boolean {
    return this.updateController?.isRunning() ?? false;
  }
}

export const videoUpdateManager = VideoUpdateManager.getInstance(); 